import 'app/main'; // import angularJs App
import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
// @ts-ignore app.module.ngfactory is autogenerated
import { AppModuleNgFactory } from 'angular/app.module.ngfactory';

enableProdMode();

platformBrowser().bootstrapModuleFactory(AppModuleNgFactory);
